import React, { useEffect, useState, useMemo } from "react";
import {
  BrowserRouter,
  Routes,
  Route,
  Navigate,
  useParams,
  useLocation,
  useNavigate,
} from "react-router-dom";
import { API, graphqlOperation, Amplify, Auth } from "aws-amplify";
import { withAuthenticator } from "@aws-amplify/ui-react";
import "./App.css";
import "@aws-amplify/ui-react/styles.css";
import awsExports from "./aws-exports";
import { listCandidateProfiles } from "./graphql/queries";
import { RiseLoader } from "react-spinners";
import { CircularProgress, Typography } from '@mui/material';
import {
  listInterviewEvaluations
} from './graphql/queries';

// JWT Expiration monitoring imports
import useJWTExpiration from './hooks/useJWTExpiration';
import JWTExpirationWarning, { JWTStatusIndicator } from './components/JWTExpirationWarning';

// Import your components here

import InterviewSlotBook from "./pages/admin/InterviewSlotBook.js";

import CandidateDashboard from "./pages/CandidateDashboard.js";
import CandidateProfileReg from "./pages/CandidateProfileReg";
import CandidateSchedule from "./pages/CandidateSchedule";
import CandidateResumeDetails from "./pages/CandidateResumeDetails.js";
import TermsPolicy from "./pages/TermsPolicy";
import CandidateProfile from "./pages/CandidateProfile.js";
import InterviewEvaluationViewer from "./components/InterviewEvaluationViewer.js";
import EditCandidateProfileReg from "./pages/EditCandidateProfileReg .js";
import AdminAddcontext from "./pages/AdminAddcontext.js";
import StudentDashbord from "./pages/StudentDashbord";
import WhoAreYou from "./pages/WhoAreYou";
import CompanyDashboard from "./pages/CompanyDashboard";
import CompanyPage from "./pages/CompanyPage.js";
import logo from "./assets/logogetscreened.svg";
import CandidateInterviewSlotList from "./pages/admin/CandidateInterviewSlotList.js";
import Header1 from "./components/Header1/Header1.js";
import CompanyCandidateViewProfile from "./pages/Company/CompanyCandidateViewProfile.js";
import CompanyCandidateViewProfilev1, { CompanyCandidateViewProfilev1Wrapper } from "./pages/Company/CompanyCandidateViewProfilev1.js";
import CompanyRegistarFrom from "./pages/Company/CompanyRegistarFrom.js";
import CompanyTerms from "./pages/Company/CompanyTerms.js";
import CompanyHome from "./pages/Company/CompanyHome.js";
import SendMail from "./pages/Company/SendMail.js";
import CompanyProfile from "./pages/Company/CompanyProfile.js";
import PrivateRoute from "./components/PrivateRoute/PrivateRoute.js";
import { listCompanyProfiles } from "./graphql/queries";
import BrowserJWTService from "./services/browserJWTService";
import CompanyJdform from "./components/company/CompanyJdform.js";
import BuyPremium from "./components/company/BuyPremium.js";
import PaymentComponent from "./components/company/PaymentComponent.js";
import Compensationbenefits from "./pages/Compensationbenefits.js";
import JobDetailsList from "./pages/Company/JobDetailsList .js";
import JobPostDetails from "./pages/Company/JobPostDetails.js";
import JobDetails from "./components/company/JobDetails.js";
import AdminCandidateViewProfile from "./pages/admin/AdminCandidateViewProfile.js";
import Showmyskill from "./pages/Showmyskill.js";
import ShowMySkills from "./pages/share/ShowMySkills.js";
import ProfilePage from "./pages/ProfilePage.js";
import AdminPrivateRoute from "./pages/admin/AdminPrivateRoute.js";
import CompanyPrivateRoute from "./pages/Company/CompanyPrivateRoute.js";
import CompanyGlobal from "./pages/Company/CompanyGlobal.js";
import UpdateCandidate from "./pages/admin/UpdateCandidate.js";
import Spot from "./pages/Company/Spot.js";
import SpotSearch from "./pages/Company/SpotSearch.js";
import SpotGPT from "./pages/Company/SpotGPT.js";
import SpotPlus from "./pages/Company/SpotPlus.js";
import SpotPlusAskAi from "./pages/Company/SpotPlusAskAi.js";
import SpotPlusCandidte from "./pages/Company/SpotPlusCandidte.js";
import SpotPlusForm from "./pages/Company/SpotPlusForm.js";
import SpotPlusJd from "./pages/Company/SpotPlusJd.js";
import SpotPlusCard from "./pages/Company/SpotPlusCard.js";
import SpotPlusSendMailPopup from "./pages/Company/SpotPlusSendMailPopup.js";
import SpotPlusCampain from "./pages/Company/SpotPlusCampain.js";
import SpotPlusStudentDetails from "./pages/Company/SpotPlusStudentDetails.js";
import SpotPlusProfile from "./pages/Company/SpotPlusProfile.js";
import SpotPlusSearch from "./pages/Company/SpotPlusSearch.js";
import SpotPlusScoreCard from "./pages/Company/SpotPlusScoreCard.js";
import SpotPlusSelectedCard from "./pages/Company/SpotPlusSelectedCard.js";
import SpotPlusYourJd from "./pages/Company/SpotPlusYourJd.js";
import { SpotProvider } from "./context/SpotContext.js";
import SpotComingSoon from "./pages/Company/SpotComingSoon.js";
import PublicInterview from "./pages/PublicInterview";
import CandidateKnowledgeGraph from "./pages/CandidateKnowledgeGraph";
import EnhancedInterviewResults from "./pages/EnhancedInterviewResults";

// Create JWT service instance
const jwtAuthService = new BrowserJWTService();

Amplify.configure(awsExports);

const HeaderWithLogo = () => (
  <div
    style={{ display: "flex", flexDirection: "column", alignItems: "center" }}
  >
    <img src={logo} alt="Logo" style={{ width: "450px" }} />
    {/* <h3 style={{ textAlign: "center" }}>Welcome to GetScreened App</h3> */}
    {/* <p style={{ textAlign: "center" }}>Powered by Varahi Technologies</p> */}
  </div>
);

function Footer() {
  return (
    <div
      style={{ textAlign: "center", marginTop: "20px", marginBottom: "10px" }}
    >
      <p>Powered by Varahi Technologies</p>
    </div>
  );
}
function App() {
  const [userProfileExists, setUserProfileExists] = useState(null);
  const [companyUserExists, setCompanyUserExists] = useState(null);
  //private route code start here

  const [email, setEmail] = useState("");
  const [companyList, setCompanyList] = useState([]);
  const [nextToken, setNextToken] = useState(null);
  const [loading, setLoading] = useState(true);
  const [company, setCompany] = useState({});

  //private route code end here
    useEffect(() => {
    // Check if this is a public route
    const currentPath = window.location.pathname;
    const isPublic = currentPath.startsWith('/public-interview/') || currentPath.startsWith('/public-profile');
    
    // Only check user profile if not a public route
    if (!isPublic) {
      checkUserProfile();
    } else {
      // For public routes, skip authentication checks completely
      setLoading(false);
    }
  }, []);

  const override = {
    display: "block",
    margin: "0 auto",
    borderColor: "red",
  };  //Private route code start here
  useEffect(() => {
    // Skip company profile check for public routes
    const companyCheckPath = window.location.pathname;
    if (companyCheckPath.startsWith('/public-interview/') || companyCheckPath.startsWith('/public-profile')) {
      return;
    }    const fetchData = async () => {
      try {
        const candidateProfileEmailID = localStorage.getItem(
          "candidateProfileEmailID"
        );
        // console.log("Email id", candidateProfileEmailID);

        if (!candidateProfileEmailID) {
          // Handle case where candidate email is not found
          return;
        }

        const { data } = await API.graphql(
          graphqlOperation(listCompanyProfiles, {
            filter: {
              email: { eq: candidateProfileEmailID },
            },
            limit: 100, // Limit the number of items per page, adjust as needed
            nextToken: nextToken, // Pass nextToken if available
          })
        );
        // console.log("compay data from app", data);
        setCompany(data.listCompanyProfiles.items[0]);
        setCompanyUserExists(true);

        if (data && data.listCompanyProfiles.items) {
          const { items, nextToken: newNextToken } = data.listCompanyProfiles;
          setCompanyList((prevList) => [...prevList, ...items]); // Merge new items with existing list
          setNextToken(newNextToken); // Set the nextToken for pagination
          setLoading(false); // Set loading to false after data is fetched
        }
      } catch (error) {
        console.error("Error fetching data:", error);
        setCompanyUserExists(false);
        // Handle error
      }
    };

    setTimeout(() => {
      fetchData();
    }, 2000);
  }, [nextToken]); // Fetch data again when nextToken changes
  //private code
  async function checkUserProfile() {
    try {
      const userInfo = await Auth.currentAuthenticatedUser();
      const userId = userInfo.attributes.sub;
      const userEmail = userInfo.attributes.email.toLowerCase();
      localStorage.setItem("candidateProfileEmailID", userEmail);
      localStorage.setItem("candidateProfileAuthID", userId);

      let nextToken = null;
      let userProfile = null;

      do {
        const userProfileData = await API.graphql(
          graphqlOperation(listCandidateProfiles, {
            filter: {
              // original getscreened code start
              // userID: {
              //   eq: userId,
              // }
              // original getscreened code end
              email: {
                eq: userEmail,
              },
            },
            limit: 100, // Adjust the limit as per your requirement
            nextToken: nextToken,
          })
        );

        const items = userProfileData.data.listCandidateProfiles.items;
        if (items.length > 0) {
          userProfile = items[0];
          localStorage.setItem("candidateProfileId", userProfile.id);
          localStorage.setItem("candidateProfile", JSON.stringify(userProfile));
          setUserProfileExists(true);
          break; // Exit the loop since a profile is found
        } else {
          // Continue to next iteration if there are more records to fetch
          nextToken = userProfileData.data.listCandidateProfiles.nextToken;
        }
      } while (nextToken);

      // If no profile found after exhausting all pages
      if (!userProfile) {
        // console.log("No profile found for this user ID.");
        setUserProfileExists(false);
      }    } catch (error) {
      console.error("Error fetching user profile", error);
      // Check if this is because there's no authenticated user (public route)
      const currentPath = window.location.pathname;
      if (currentPath.startsWith('/public-interview/') || currentPath.startsWith('/public-profile')) {
        // For public routes, this is expected - don't set profile as false
        setUserProfileExists(null); // Keep as null for public routes
        setLoading(false);
        return;
      }
      setUserProfileExists(false);
    }  }  
    // console.log("11111111111111111111111111111111111111", userProfileExists);
  // console.log("222222222222222222222222222222222222", companyUserExists);
  
  // Show loading when user profile is still being checked
  if (userProfileExists === null && loading) {
    return (
      <div className="flex justify-center items-center h-screen">
        <RiseLoader
          color={"#ffffff"}
          loading={loading}
          css={override}
          size={40}
          aria-label="Loading Spinner"
        />
      </div>
    );
  } else {
    return (
      <BrowserRouter 
        future={{
          v7_startTransition: true,
          v7_relativeSplatPath: true
        }}
      >
        <Routes>
          <Route
            path="/"
            element={
              // userProfileExists ? <CandidateDashboard /> : <WhoAreYou />
              // userProfileExists ? <SendMail /> : <WhoAreYou />
              // userProfileExists && companyUserExists ? <PrivateRoute/> : <WhoAreYou />
              company || userProfileExists ? <PrivateRoute /> : <WhoAreYou />
              // userProfileExists ? <WhoAreYou /> : <TermsPolicy />
              // userProfileExists ? <CandidateResumeDetails  /> : <TermsPolicy />
            }
          />
          <Route
            path="/CandidateProfileReg"
            element={<CandidateProfileReg />}
          />
          <Route path="/TermsPolicy" element={<TermsPolicy />} />

          <Route path="/CompanyPage" element={<CompanyPage />} />
          <Route path="/CandidateSchedule" element={<CandidateSchedule />} />
          <Route path="/CandidateProfile" element={<CandidateProfile />} />
          <Route path="/StudentDashboard" element={<StudentDashbord />} />

          {/* <Route path="/InterviewSlotBook" element={<InterviewSlotBook />} /> */}

          <Route path="/PaymentComponent" element={<PaymentComponent />} />
          <Route path="/CompanyJdform" element={<CompanyJdform />} />

          <Route path="/JobPostDetails" element={<JobPostDetails />} />

          <Route path="/CompanyProfile" element={<CompanyProfile />} />
          <Route path="/Showmyskill" element={<Showmyskill />} />
          <Route path="/ShowMySkills" element={<ShowMySkills />} />          
          <Route path="/ProfilePage" element={<ProfilePage />} />
          <Route path="/interview-evaluations" element={<InterviewEvaluationViewer />} />
          <Route path="/public-interview/:accessToken" element={<PublicInterview />} />
          <Route path="/public-profile" element={<PublicProfileWrapper />} />
          {/* Knowledge Graph Route */}
          <Route
            path="/candidate-knowledge-graph/:email?"
            element={<CandidateKnowledgeGraph />}
          />

          {/* Admin Private Route start */}

          <Route element={<AdminPrivateRoute />}>
            <Route path="/AdminAddcontext" element={<AdminAddcontext />} />
            <Route path="/InterviewSlotBook" element={<InterviewSlotBook />} />
            <Route
              path="/CandidateInterviewSlotList"
              element={<CandidateInterviewSlotList />}
            />
            <Route path="/CompanyDashboard" element={<CompanyDashboard />} />
            <Route
              path="/AdminCandidateViewProfile"
              element={<AdminCandidateViewProfile />}
            />
            <Route path="/UpdateCandidate" element={<UpdateCandidate />} />
          </Route>

          {/* Admin Private Route end */}

          {/* Company Private Route start */}

          <Route element={<CompanyPrivateRoute />}>
            <Route path="/JobDetailsList" element={<JobDetailsList />} />
            <Route path="/JobDetails" element={<JobDetails />} />
            <Route path="/SendMail" element={<SendMail />} />
            <Route
              path="/CompanyCandidateViewProfile/:email"
              element={<CompanyCandidateViewProfileWrapper />}
            />
            <Route path="/Spot" element={<Spot />} />
            <Route path="/SpotSearch" element={<SpotSearch />} />
            <Route path="/SpotGPT" element={<SpotGPT />} />

            <Route path="/SpotPlus" element={<SpotPlus />} />

            {/* testing code start */}

            <Route
              path="/SpotPlusAskAi"
              element={
                <SpotProvider>
                  <SpotPlusAskAi />
                </SpotProvider>
              }
            />

            <Route
              path="/SpotPlusCandidte"
              element={
                <SpotProvider>
                  <SpotPlusCandidte />
                </SpotProvider>
              }
            />

            {/* testing code end */}

            <Route path="/SpotPlusForm" element={<SpotPlusForm />} />
            <Route path="/SpotPlusJd" element={<SpotPlusJd />} />
            <Route path="/SpotPlusCard" element={<SpotPlusCard />} />
            <Route path="/SpotPlusProfile" element={<SpotPlusProfile />} />
            <Route path="/SpotPlusSearch" element={<SpotPlusSearch />} />
            <Route path="/SpotPlusYourJd" element={<SpotPlusYourJd />} />
            <Route
              path="/SpotPlusSendMailPopup"
              element={<SpotPlusSendMailPopup />}
            />
            <Route path="/SpotPlusCampain" element={<SpotPlusCampain />} />
            <Route
              path="/SpotPlusStudentDetails"
              element={<SpotPlusStudentDetails />}
            />
            <Route path="/SpotComingSoon" element={<SpotComingSoon />} />

          </Route>
          {/* Company Private Route end */}

          <Route
            path="/CompanyCandidateViewProfilev1/:email"
            element={<CompanyCandidateViewProfileWrapperv1 />}
          />


          <Route path="/CompanyGlobal" element={<CompanyGlobal />} />

          <Route
            path="/Compensationbenefits"
            element={<Compensationbenefits />}
          />
          {/* commented for im not getting props alter net got below from ooriginal  */}
          {/* <Route path="/CompanyCandidateViewProfile" element={<CompanyCandidateViewProfile />} /> */}

          <Route
            path="/CompanyRegisterForm"
            element={<CompanyRegistarFrom />}
          />
          <Route path="/CompanyTerms" element={<CompanyTerms />} />
          <Route path="/CompanyHome" element={<CompanyHome />} />
          <Route path="/PrivateRoute" element={<PrivateRoute />} />
          <Route path="/BuyPremium" element={<BuyPremium />} />

          {/* <Route path="/Header" element={<Header1 />} /> */}

          <Route
            path="/CandidateResumeDetails"
            element={<CandidateResumeDetails />}
          />
          <Route
            path="/EditCandidateProfileReg"
            element={<EditCandidateProfileReg />}
          />
          <Route path="/SpotPlusScoreCard" element={<SpotPlusScoreCard />} />
          <Route
            path="/SpotPlusSelectedCard"
            element={<SpotPlusSelectedCard />}
          />

          {/* Redirect all other paths to dashboard or terms based on the profile existence */}
          <Route path="*" element={<Navigate to="/" />} />
        </Routes>
      </BrowserRouter>
    );
  }
}

const CompanyCandidateViewProfileWrapper = () => {
  const { email } = useParams();
  const location = useLocation();
  return <CompanyCandidateViewProfile email={email} {...location.state} />;
};

const CompanyCandidateViewProfileWrapperv1 = () => {
  const { email } = useParams();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const slotId = searchParams.get('slotId') || searchParams.get('slot-id'); // Support both formats


  try {
    return (
      <CompanyCandidateViewProfilev1Wrapper
        emailProp={email}
        slotIdProp={slotId}
        skipFetch={false}
      />
    );
  } catch (error) {
    console.error("❌ Error in CompanyCandidateViewProfileWrapperv1:", error);
    return <div>Error loading component: {error.message}</div>;
  }
};

// Public Profile Wrapper for iframe embedding and public access with expiration
// Supports two flows:
// 1) JWT token in `?token=` — validated by integrated JWT service with real-time monitoring
// 2) Legacy params `e` (email), `t` (timestamp) — client-side expiry (default 5 minutes)
const PublicProfileWrapper = () => {
  const location = useLocation();
  
  // State management
  const [email, setEmail] = useState(null);
  const [slotIdFromToken, setSlotIdFromToken] = useState(null);
  const [loading, setLoading] = useState(true);
  const [isAdminUser, setIsAdminUser] = useState(false);
  const [expired, setExpired] = useState(false);
  const [errorMsg, setErrorMsg] = useState(null);

  // Extract URL parameters - memoized to prevent recreating object on every render
  const urlParams = useMemo(() => {
    const searchParams = new URLSearchParams(location.search);
    return {
      token: searchParams.get('token'),
      encodedEmail: searchParams.get('e') || searchParams.get('email'),
      slotId: searchParams.get('slot') || searchParams.get('slot-id'),
      timestamp: searchParams.get('t')
    };
  }, [location.search]);

  // JWT Expiration monitoring - only for tokens
  const jwtHook = useJWTExpiration(urlParams.token, {
    onExpire: () => {
      console.log('JWT expired in hook');
      setExpired(true);
    },
    onWarning: () => {},
    warningThreshold: 30,
    autoRedirect: false,
    enableWarnings: false
  });

  // Initialize component - runs only when URL parameters change
  useEffect(() => {
    const initializeComponent = async () => {
      console.log('Initializing PublicProfileWrapper with params:', urlParams);
      
      try {
        if (urlParams.token) {
          // JWT token flow
          const result = jwtAuthService.validateJWTToken(urlParams.token);
          
          if (!result.success) {
            console.error('JWT validation failed:', result.error);
            setErrorMsg('Invalid or expired token: ' + result.error);
            setExpired(true);
            setLoading(false);
            return;
          }

          const decodedEmail = result.email;
          const decodedSlotId = result.slotId;
          const adminEmail = 'getscreened@varahitechnologies.com';
          const isAdmin = decodedEmail === adminEmail;
          
          setEmail(decodedEmail);
          setSlotIdFromToken(decodedSlotId);
          setIsAdminUser(isAdmin);
          
          // Check if token is already expired for non-admin users
          if (result.timeRemaining <= 0 && !isAdmin) {
            setExpired(true);
          }
        } else {
          // Legacy flow
          const tryDecodeEmail = (enc) => {
            if (!enc) return null;
            try {
              if (/^[A-Za-z0-9+/]*={0,2}$/.test(enc)) {
                return atob(enc);
              }
              return enc;
            } catch (e) {
              return enc;
            }
          };

          const decoded = tryDecodeEmail(urlParams.encodedEmail);
          const adminEmail = 'getscreened@varahitechnologies.com';
          const isAdmin = decoded === adminEmail;
          
          if (!decoded) {
            setErrorMsg('Missing email parameter');
            setLoading(false);
            return;
          }
          
          setEmail(decoded);
          setIsAdminUser(isAdmin);

          // Check timestamp validity for non-admin users
          if (urlParams.timestamp && !isAdmin) {
            const VALIDITY_MS = 5 * 60 * 1000; // 5 minutes
            const t = parseInt(urlParams.timestamp, 10);
            const expiryMs = t + VALIDITY_MS;
            
            if (Date.now() > expiryMs) {
              setExpired(true);
              setLoading(false);
              return;
            }
          } else if (!urlParams.timestamp && !isAdmin) {
            setErrorMsg('Missing timestamp');
            setLoading(false);
            return;
          }
        }
      } catch (err) {
        console.error('🔍 Token validation error:', err);
        setErrorMsg('Invalid or expired token: ' + err.message);
        setExpired(true);
      }
      
      setLoading(false);
    };

    initializeComponent();
  }, [urlParams.token, urlParams.encodedEmail, urlParams.slotId, urlParams.timestamp]); // Only depend on primitive values

  // Handle JWT expiration from the hook
  useEffect(() => {
    if (jwtHook.isExpired && !isAdminUser && urlParams.token) {
      console.log('JWT expired, setting expired state');
      setExpired(true);
    }
  }, [jwtHook.isExpired, isAdminUser, urlParams.token]);

  // Auto-redirect when expired
  useEffect(() => {
    if (expired && !isAdminUser) {
      console.log('Redirecting due to expiration');
      const timer = setTimeout(() => {
        window.location.href = '/';
      }, 3000);
      
      return () => clearTimeout(timer);
    }
  }, [expired, isAdminUser]);

  if (loading) {
    return (
      <div className="flex justify-center items-center h-screen">
        <RiseLoader color={"#ffffff"} loading={true} css={{ display: 'block', margin: '0 auto' }} size={40} />
      </div>
    );
  }

  if (expired && !isAdminUser) {
    // Redirect immediately for expired tokens
    window.location.href = '/';
    return null;
  }

  if (errorMsg) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh', fontFamily: 'Arial, sans-serif', color: '#666' }}>
        <div>
          <h2>Invalid Profile Link</h2>
          <p>{errorMsg}</p>
          <p>Please contact the administrator for a valid profile link.</p>
        </div>
      </div>
    );
  }

  if (!email) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh', fontFamily: 'Arial, sans-serif', color: '#666' }}>
        <div>
          <h2>Invalid Profile Link</h2>
          <p>The profile link appears to be missing an email.</p>
          <p>Please contact the administrator for a valid profile link.</p>
        </div>
      </div>
    );
  }

  try {
    const finalSlotId = slotIdFromToken || urlParams.slotId;
    
    return (
      <CompanyCandidateViewProfilev1Wrapper
        emailProp={email}
        slotIdProp={finalSlotId}
        skipFetch={false}
        isPublicAccess={true}
        isAdminAccess={isAdminUser}
      />
    );
  } catch (error) {
    console.error("❌ Error in PublicProfileWrapper:", error);
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh', fontFamily: 'Arial, sans-serif', color: '#ff6b6b' }}>
        <div>
          <h2>Error Loading Profile</h2>
          <p>There was an error loading the candidate profile.</p>
          <p>Error: {error.message}</p>
        </div>
      </div>
    );
  }
};

// Create a wrapper component to handle authentication selectively
const AppWrapper = () => {
  const [isPublicRoute, setIsPublicRoute] = useState(false);
  
  useEffect(() => {
    // Check if current path is a public route
    const checkRoute = () => {
      const currentPath = window.location.pathname;
      setIsPublicRoute(
        currentPath.startsWith('/public-interview/') || 
        currentPath.startsWith('/public-profile')
      );
    };
    
    // Check on mount
    checkRoute();
    
    // Listen for route changes
    const handleLocationChange = () => {
      checkRoute();
    };
    
    // Listen for browser navigation events
    window.addEventListener('popstate', handleLocationChange);
    
    return () => {
      window.removeEventListener('popstate', handleLocationChange);
    };
  }, []);
  
  // If it's a public route, render the app without authentication
  if (isPublicRoute) {
    return <App />;
  }
  
  // For all other routes, require authentication
  const AuthenticatedApp = withAuthenticator(App, {
    components: { Header: HeaderWithLogo, Footer: Footer },
  });
  
  return <AuthenticatedApp />;
};

export default AppWrapper;
